import mediaAPI from "@/api/media";
import ukdAPI from "@/api/ukd";

const state = {
  canceledGoods: [],
  currentUkdImageLink: null,
};

const mutations = {
  setCurrentUkdImageLink(state, payload) {
    state.currentUkdImageLink = payload;
  },
  removeCurrentUkdImageLink(state) {
    state.currentUkdImageLink = null;
  },
  attachPhoto(state, payload) {
    state.canceledGoods.forEach(function (item, index) {
      if (item.draftUkdUuid === payload.draftUkdUuid) {
        item.images = [payload.data["@id"]];
        state.canceledGoods.splice(index, 1, item);
      }
    });
  },
  setCanceledGood(state, payload) {
    state.canceledGoods.push({
      draftUkdUuid: payload.draftUkdUuid,
      updNumber: payload.upd.docNumber,
      updExtId: payload.upd.extid,
      contractExtId: payload.upd.contractor.contract.id,
      articleExtId: payload.goodExtId,
      quantity: payload.quantity,
      reasonType: Number.parseInt(payload.reason),
      linkMaster: payload.linkMaster,
      images: payload.images,
    });
  },
  removeCanceledGood(state, payload) {
    state.canceledGoods.forEach(function (item, index) {
      if (item.draftUkdUuid === payload.draftUkdUuid) {
        state.canceledGoods.splice(index, 1);
      }
    });
  },
  clearCanceledGoods(state) {
    state.canceledGoods = [];
  },
  clearCancelledGoodList(state) {
    state.canceledGoods = [];
  },
};

const getters = {
  getcanceledGoods(state) {
    return state.canceledGoods;
  },
  getCurrentUkdImageLink(state) {
    return state.currentUkdImageLink;
  },
};

const actions = {
  setCurrentUkdImageLink(context, payload) {
    context.commit("setCurrentUkdImageLink", payload);
  },
  send_media(context, payload) {
    return new Promise((resolve, reject) => {
      mediaAPI
        .send_media(payload.img)
        .then((response) => {
          context.commit("attachPhoto", {
            data: response.data,
            draftUkdUuid: payload.draftUkdUuid,
          });
          resolve(response.data);
        })
        .catch((result) => {
          reject(result);
        });
    });
  },
  ukd_goods_all(context, payload) {
    let ukdGoods = [];
    for (let good of payload.upd.goods) {
      ukdGoods.push({
        updNumber: payload.upd.docNumber,
        updExtId: payload.upd.extid,
        contractExtId: payload.upd.contractor.contract.id,
        articleExtId: good.extid,
        quantity: good.quantity,
        reasonType: Number.parseInt(payload.reason),
        linkMaster: good.linkMaster,
        images: [],
      });
    }
    const ukd = {
      updSearchNumber: payload.upd.searchNumber,
      ukdGoods: ukdGoods,
    };
    return new Promise((resolve, reject) => {
      ukdAPI
        .ukd_goods(ukd)
        .then((response) => {
          resolve(response.data);
        })
        .catch((result) => {
          reject(result);
        });
      context.commit("clearCancelledGoodList");
    });
  },
  ukd_goods(context, payload) {
    const ukd = {
      updSearchNumber: payload.updSearchNumber,
      ukdGoods: payload.ukdGoods,
    };

    return new Promise((resolve, reject) => {
      ukdAPI
        .ukd_goods(ukd)
        .then((response) => {
          resolve(response.data);
        })
        .catch((result) => {
          reject(result);
        });
      context.commit("clearCancelledGoodList");
    });
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};
